import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["onClick"]
const _hoisted_2 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "burger-button",
  title: "Menu"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "burger-bar burger-bar--1" }),
  /*#__PURE__*/_createElementVNode("span", { class: "burger-bar burger-bar--2" }),
  /*#__PURE__*/_createElementVNode("span", { class: "burger-bar burger-bar--3" })
], -1)

import { ref } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'Burger',
  setup(__props) {

const isBurgerActive = ref(false);
const toggle = () => {
  isBurgerActive.value = !isBurgerActive.value;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    id: "burger",
    class: _normalizeClass({ active: isBurgerActive.value }),
    onClick: _withModifiers(toggle, ["prevent"])
  }, [
    _renderSlot(_ctx.$slots, "default", {}, () => [
      _hoisted_2
    ])
  ], 10, _hoisted_1))
}
}

})